// Used Google Tag Manager to track events, google tag manager is configured in main.tsx
// The following events is being triggered because GTM is listening to the events here posted
// Once you have a new tracking event, you can add it here and then create the event in GTM (Custom event)

import { IPlan } from "~/types/billing";
import { googleTagManagerKey } from "./environment";
import { getGclid } from "./analytics";

export function sendLPDataGoogleAds({
  email,
  name,
  phone,
}: {
  email: string;
  name: string;
  phone?: string;
}) {
  triggerGTMEvent({
    event: "contactFormSubmitted",
    LP_Data: {
      name: name || "",
      email: email || "",
      phone: phone || "",
    },
  });
}

export const triggerGTMEvent = (eventData: {
  event: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  value?: string;
  [key: string]: any;
}) => {
  if (!googleTagManagerKey) {
    const { event, ...rest } = eventData;
    console.log(`[GTM Event - ${event}]`, rest);
    return;
  }

  // @ts-ignore
  if (window.dataLayer) {
    const gclid = getGclid();
    if (gclid) {
      eventData.gclid = gclid;
    }
    // @ts-ignore
    window.dataLayer.push(eventData);
  }
};

export function triggerGtagPurchaseEvent(plan: IPlan) {
  const eventBasedOnPlanKey = {
    "starter-monthly": "purchaseStarter",
    "pro-monthly": "purchaseProMonthly",
    "pro-yearly": "purchaseProYearly",
    "empire-monthly": "purchaseEmpireMonthly",
    "empire-yearly": "purchaseEmpireYearly",
    "unicorn-monthly": "purchaseUnicornMonthly",
    "unicorn-yearly": "purchaseUnicornYearly",
  };
  const planKey = `${plan.name.toLowerCase()}-${plan.interval}`;
  const event =
    eventBasedOnPlanKey[planKey as keyof typeof eventBasedOnPlanKey];
  try {
    // @ts-ignore
    triggerGTMEvent({ event });
  } catch (err) {
    console.log(err);
  }
}

export function triggerStartedTrialEvent() {
  try {
    // @ts-ignore
    triggerGTMEvent({ event: "startedTrial" });
  } catch (err) {
    console.log(err);
  }
}

export function triggerSignupEvent() {
  try {
    // @ts-ignore

    triggerGTMEvent({ event: "userRegisterSuccess" });
  } catch (err) {
    console.log(err);
  }
}
